import { createRouterLinks } from "@/models/router";
import { RouteConfig } from "vue-router";
import { REmployeeCompany } from "./views/Company/REmployeeCompany";
import { REmployeeGuide } from "./views/Guide/REmployeeGuide";
import { REmployeeHome } from "./views/Home/REmployeeHome";
import { REmployeeProfile } from "./views/Profile/REmployeeProfile";
import { REmployeeServices } from "./views/Services/REmployeeServices";
import { REmployeeTasks } from "./views/Tasks/REmployeeTasks";
// import { REmployeeCopilot } from "./views/Copilot/REmployeeCopilot";

export const REmployee: RouteConfig = {
  path: "employee",
  component: () =>
    import(
      /* webpackChunkName: "employee" */
      "./VEmployee.vue"
    ),
  children: [
    {
      path: "",
      redirect: REmployeeHome.path,
    },
    REmployeeHome,
    REmployeeProfile,
    REmployeeTasks,
    REmployeeGuide,
    REmployeeServices,
    REmployeeCompany,
    // REmployeeCopilot,
  ],
};

export const employeeLinks = createRouterLinks(REmployee);
